import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import { useTranslation } from "react-i18next";
import DataTable from "../components/common/DataTable";
import CustomModal from "../components/common/CustomModal";
import CreateOrderPlanning from "../components/OrderPlanning/CreateOrderPlanning";
import { Delete_Lead_leadId, DELETE_ORDER_PLANNING, GET_LEADS, LIST_ALL_EXPORT_SHIPMENT, LIST_ALL_IMPORT_SHIPMENT, LIST_ALL_ORDER_PLANNING, ORDER_PLANNING_ASSIGN_SHIPMENT, } from "../services/apiRoutes"
import { genericGet } from "../services/apiServices"
import { getClientCompany, getColorPlate, getCurrencyList, } from "../services/CommonServices";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import axios from 'axios';
import CustomLoader from "../components/common/CustomLoader";
import MessageBox from "../components/common/CustomMessageBox";
import CustomDelete from '../components/common/CustomDeleteAlert'
import { AuthContext } from "../context/AuthContext";
import CustomFilter from "../components/common/CustomFilter";
import CustomTextField from "../components/common/CustomTextField";
import CustomAutocomplete from "../components/common/CustomAutoComplete";
import { ClearRounded } from "@mui/icons-material";
import CustomButton from "../components/common/CustomButton";
import FindReplaceOutlinedIcon from '@mui/icons-material/FindReplaceOutlined';
import { hasEditPermission, hasDeletePermission } from '../services/CommonServices'
import { useLocation } from "react-router-dom";
import CustomStatus from "../components/common/CustomStatus";
import { genericPost } from "../services/authServices";
import { useCompanyDateFormat } from "../constants/useCompanyDateFormat";
import { t } from "../constants/translationHelper";
import CustomDataTable from "../components/common/CustomDataTable";
import UpdateOrderPlanning from "../components/OrderPlanning/UpdateOrderPlanning";
import ViewOrderPlanning from "../components/OrderPlanning/ViewOrderPlanning";

const getStatusStyle = (status) => {
  switch (status) {
    case "Active":
      return {
        backgroundColor: "#E8F5E9", // Light Green
        color: "#1B5E20",
        border: "1px solid #81C784",
      };

    case "Hold":
      return {
        backgroundColor: "#FFF8E1", // Light Amber
        color: "#E65100",
        border: "1px solid #FFCC80",
      };

    case "Cancel":
      return {
        backgroundColor: "#FDECEC", // Light Red
        color: "#B71C1C",
        border: "1px solid #EF9A9A",
      };

    default:
      return {
        backgroundColor: "#F5F5F5",
        color: "#424242",
        border: "1px solid #E0E0E0",
      };
  }
};

const getOrderTypeStyle = (type) => {
  switch (type) {
    case "Import Order":
      return {
        backgroundColor: "#E3F2FD", // Light Blue
        color: "#0D47A1",
        border: "1px solid #90CAF9",
      };

    case "Export Order":
      return {
        backgroundColor: "#F3E5F5", // Light Purple
        color: "#6A1B9A",
        border: "1px solid #CE93D8",
      };

    default:
      return {
        backgroundColor: "#F5F5F5",
        color: "#424242",
        border: "1px solid #E0E0E0",
      };
  }
};

const OrderPlanning = () => {

  const statusList = [
    { id: "1", title: "Active" },
    { id: "2", title: "Hold" },
    { id: "3", title: "Cancel" }
  ];
  const orderTypeList = [
    { id: "0", title: "Import Order" },
    { id: "1", title: "Export Order" }
  ];

  // const { t, i18n } = useTranslation();
  const title = "Order Planning";
  const companyDateFormat = useCompanyDateFormat();
  const navigate = useNavigate();
  const { token } = useContext(AuthContext)
  const [leadModal, setLeadModal] = useState(false);
  const [updateLeadModal, setUpdateLeadModal] = useState(false);
  const [getAllLead, setGetAllLead] = useState([]);
  const [clientCompany, setClientCompany] = useState([]);
  const [colorlist, setColorlist] = useState([]);
  const [loading, setLoading] = useState(false)
  const [deleteAlert, setDeleteAlert] = useState(false)
  const [rowId, setRowId] = useState('')
  const [openDrawer, setOpenDrawer] = useState(false);
  const [permission, setPermissions] = useState()
  const [page, setPage] = useState(0); // UI 0-based
  const [pageSize, setPageSize] = useState(10);
  const [rowCount, setRowCount] = useState(0);
  const [currencyList, setCurrencyList] = useState([]);
  const [selectedOrderPlanningId, setSelectedOrderPlanningId] = useState(null);
  const [newOrderPlanningId, setNewOrderPlanningId] = useState(null);
  const [viewLeadModal, setViewLeadModal] = useState(false);
  const [importShipments, setImportShipments] = useState([]);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [selectedShipments, setSelectedShipments] = useState({});
  const [exportShipments, setExportShipments] = useState([]);
  const [selectedExportShipments, setSelectedExportShipments] = useState({});
  const [filterPayload, setFilterPayload] = useState({
    orderNo: "",
    shipmentId: "",
    clientId: "",
    currencyId: "",
    status: "",
    fromDate: "",
    toDate: "",
    commanShipmentId: "",
  });
  const currentDate = new Date();
  const sevenDaysAgo = new Date(currentDate);
  sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
  const [message, setMessage] = useState({
    open: false,
    text: '',
    type: ''
  })
  const filterOpen = () => setOpenDrawer(true);
  const filterClose = () => setOpenDrawer(false);
  const handleViewClick = (orderPlanningId) => {
    setSelectedOrderPlanningId(orderPlanningId);
    setViewLeadModal(true);
  };
  const handleCloseViewLead = () => {
    setViewLeadModal(false);
    setSelectedOrderPlanningId(null);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "index", header: "SN.", size: 50, tableHeader: { alignItems: 'center', }, tableStyle: { textAlign: "center" },
        enableSorting: true,
        enableColumnFilter: true
      },
      { accessorKey: "date", header: "Date", size: 100, tableStyle: { textAlign: "center" }, enableSorting: false, },
      {
        accessorKey: "clientName", header: "Company", size: 150, enableSorting: false, tableHeader: {
          justifyContent: 'flex-start',
        },
      },

      {
        accessorKey: "orderNo", header: "Order No", size: 50, enableSorting: false, tableHeader: {
          justifyContent: 'flex-start',
        },
      },
      {
        accessorKey: "shipmentId", header: "Shipment No", size: 50, enableSorting: false, tableHeader: {
          justifyContent: 'flex-start',
        },
      },
      {
        accessorKey: "currency", header: "Currency", size: 50, enableSorting: false,
        tableHeader: {
          justifyContent: 'flex-start',
        },
      },
      {
        accessorKey: "statusTitle",
        header: "Status",
        size: 90,
        tableStyle: { textAlign: "center" },
        Cell: ({ row }) => {
          const style = getStatusStyle(row.original.statusTitle);
          return (
            <Box
              sx={{
                ...style,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                px: 1.5,
                py: 0.5,
                minWidth: 85,
                borderRadius: "5px",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              {row.original.statusTitle}
            </Box>
          );
        },
      },
      {
        accessorKey: "orderTypeTitle",
        header: "Order Type",
        size: 140,
        tableStyle: { textAlign: "center" },
        Cell: ({ row }) => {
          const style = getOrderTypeStyle(row.original.orderTypeTitle);

          return (
            <Box
              sx={{
                ...style,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                px: 1.5,
                py: 0.5,
                minWidth: 120,
                borderRadius: "5px",
                fontSize: "13px",
                fontWeight: 600,
              }}
            >
              {row.original.orderTypeTitle}
            </Box>
          );
        },
      },
      {
        accessorKey: "etd",
        header: "ETD",
        size: 20,
        tableStyle: { textAlign: "center", },
        enableSorting: false
      },
      {
        accessorKey: "eta",
        header: "ETA",
        size: 20,
        tableStyle: { textAlign: "center", },
        enableSorting: false
      },
      {
        accessorKey: "shipmentId",
        header: "Shipment",
        size: 180,
        Cell: ({ row }) => {
          const isImport = String(row.original.commanShipmentId) === "0";
          const isExport = String(row.original.commanShipmentId) === "1";
          const options = isImport ? importShipments : exportShipments;
          const selectedValue =
            options.find(
              (item) =>
                item.id ===
                (isImport
                  ? selectedShipments[row.original.orderPlanningId]
                  : selectedExportShipments[row.original.orderPlanningId]) ??
                row.original.shipmentId
            ) || options[0];

          return (
            <CustomAutocomplete
              options={options}
              placeholder={
                isImport
                  ? "Select Import Shipment"
                  : "Select Export Shipment"
              }
              getOptionLabel={(option) => option?.title || ""}
              isOptionEqualToValue={(option, value) =>
                option.id === value.id
              }
              value={selectedValue}
              onOpen={() => {
                if (isImport) {
                  fetchImportShipments(row.original.clientId);
                } else if (isExport) {
                  fetchExportShipments(row.original.clientId);
                }
              }}
              onChange={(event, newValue) => {
                const shipmentId = newValue?.id || "";

                if (isImport) {
                  setSelectedShipments((prev) => ({
                    ...prev,
                    [row.original.orderPlanningId]: shipmentId,
                  }));
                } else {
                  setSelectedExportShipments((prev) => ({
                    ...prev,
                    [row.original.orderPlanningId]: shipmentId,
                  }));
                }

                updateOrderPlanning(
                  row.original.orderPlanningId,
                  shipmentId
                );
              }}
            />
          );
        },
        enableSorting: false,
      },
      {
        accessorKey: "action",
        header: "Action",
        size: 100,
        Cell: ({ row }) => (
          <>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
              <IconButton onClick={() => handleViewClick(row.original.orderPlanningId)}>
                <VisibilityIcon style={{ color: "#059212" }} />
              </IconButton>
              {permission?.edit &&
                <IconButton onClick={() => handleUpdateClick(row.original.orderPlanningId)}>
                  <ModeEditOutlineOutlinedIcon style={{ color: "#050C9C" }} />
                </IconButton>
              }
              {permission?.delete && <IconButton onClick={() => handleOpenDeleteAlert(row.original.orderPlanningId)}>
                <DeleteOutlineOutlinedIcon style={{ color: "#E4003A" }} />
              </IconButton>}
            </div>
          </>

        ),
        enableSorting: false,
      },

    ],
    [permission, importShipments, exportShipments, selectedExportShipments,]
  );

  const handleUpdateClick = (orderPlanningId) => {
    setSelectedOrderPlanningId(orderPlanningId);
    setUpdateLeadModal(true);
  };

  const handleCloseUpdateLead = () => {
    setUpdateLeadModal(false);
    setSelectedOrderPlanningId(null);
  };
  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    let rolePermisionsData = JSON.parse(sessionStorage.getItem('userData')) || []
    let editPermision = hasEditPermission(currentPath, rolePermisionsData?.permissions)
    let deletePermission = hasDeletePermission(currentPath, rolePermisionsData?.permissions)
    setPermissions({
      edit: editPermision,
      delete: deletePermission
    })
  }, [])

  const handleDelete = async (orderPlanningId) => {
    setLoading(true)
    const authToken = sessionStorage.getItem('accessToken');
    try {
      const response = await axios.delete(DELETE_ORDER_PLANNING(orderPlanningId), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        getLeadList()
        setDeleteAlert(false)
        setMessage({
          open: true,
          text: response?.data?.message || "Delete successfully",
          type: "success",
        });
      } else {
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("Error deleting lead", error);
    }
  };

  const handleFilterChange = (field, value) => {
    setFilterPayload((prev) => ({
      ...prev,
      [field]: value || '',
    }));
  };
  // @@@@@@@@@@@@@@@@@@@ start
  const handleClearFilters = useMemo(() => {
    return () => {
      setFilterPayload({
        orderNo: "",
        shipmentId: "",
        clientId: "",
        currencyId: "",
        status: "",
        fromDate: "",
        toDate: "",
        commanShipmentId: "",
      });
      getLeadList(0, pageSize, '');
    };
  }, [pageSize]);

  // @@@@@@@@@@@@@@@@@@@  import start 
  const fetchExportShipments = async (customerId) => {
    try {
      const payload = {
        page: 1,
        limit: 1000,
        customerId,
      };

      const response = await genericPost(
        LIST_ALL_EXPORT_SHIPMENT,
        payload,
        {}
      );

      if (response?.data?.success) {
        const shipmentList = [
          {
            id: "",
            title: "Select Option",
          },
          ...(response.data.shipments || []).map((item) => ({
            id: item.exportShipmentId,
            title: item.shipmentId,
          })),
        ];

        setExportShipments(shipmentList);
      } else {
        setExportShipments([
          {
            id: "",
            title: "Select Option",
          },
        ]);
      }
    } catch (error) {
      console.error(error);

      setExportShipments([
        {
          id: "",
          title: "Select Option",
        },
      ]);
    }
  };
  const fetchImportShipments = async (supplierId) => {
    try {
      const payload = {
        page: 1,
        limit: 1000,
        supplierId,
      };

      const response = await genericPost(
        LIST_ALL_IMPORT_SHIPMENT,
        payload,
        {}
      );

      if (response?.data?.success) {
        const shipmentList = [
          {
            id: "",
            title: "Select Option",
          },
          ...(response.data.shipments || []).map((item) => ({
            id: item.importShipmentId,
            title: item.shipmentId,
          })),
        ];

        setImportShipments(shipmentList);

        console.log("SupplierId :", supplierId);
        console.log("Shipment List :", shipmentList);
      } else {
        setImportShipments([
          {
            id: "",
            title: "Select Option",
          },
        ]);
      }
    } catch (error) {
      console.error("Shipment Fetch Error :", error);

      setImportShipments([
        {
          id: "",
          title: "Select Option",
        },
      ]);
    }
  };
  const updateOrderPlanning = async (orderPlanningId, shipmentId) => {
    try {
      const accessToken = sessionStorage.getItem("accessToken");

      const payload = {
        shipmentOrgId: shipmentId,
      };


      const response = await axios.put(
        ORDER_PLANNING_ASSIGN_SHIPMENT(orderPlanningId),
        payload,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.status === 200) {
        setMessage({
          open: true,
          text: response.data.message || "Shipment updated successfully",
          type: "success",
        });

        getLeadList(page, pageSize);
      }
    } catch (error) {
      console.error(error);

      setMessage({
        open: true,
        text: error?.response?.data?.message || "Update failed",
        type: "error",
      });
    }
  };
  // @@@@@@@@@@@@@@@@@@@ import end

  const getLeadList = async (pageIndex = 0, pageSize = 10) => {
    setLoading(true)
    try {
      const payload = {
        page: pageIndex + 1,
        limit: pageSize,
        ...filterPayload
      };
      const response = await genericPost(LIST_ALL_ORDER_PLANNING, payload, {});
      if (response?.data?.orderPlanning) {
        const orderPlanningData = response.data.orderPlanning.map((item, index) => {
          const statusObj = statusList.find(
            (status) => status.id === String(item.status)
          );
          const orderTypeObj = orderTypeList.find(
            (type) => type.id === String(item.commanShipmentId)
          );
          return {
            ...item,
            index: (index + 1).toString().padStart(2, '0'),
            id: item.orderPlanningId || "",
            orderPlanningId: item.orderPlanningId || "",
            orderNo: item.orderNo || "",
            commanShipmentId: item.commanShipmentId || "",
            shipmentId: item.shipmentId || "",
            clientId: item.clientId || "",
            clientName: item.client?.clientCompanyName || "",
            currency: item.currency
              ? `${item.currency.currency_symbol} ${item.currency.currency_name}`
              : "",
            status: item.status || "",
            statusTitle: statusObj?.title || "",
            commanShipmentId: item.commanShipmentId || "",
            orderTypeTitle: orderTypeObj?.title || "",
            date: companyDateFormat(item.date) || "",
            etd: companyDateFormat(item.eTD) || "",
            eta: companyDateFormat(item.eTA) || "",
            notes: item.notes || "",
            createdAt: companyDateFormat(item.createdAt) || "",
            updatedAt: companyDateFormat(item.updatedAt) || "",
          };
        });
        setGetAllLead(orderPlanningData);
        setNewOrderPlanningId(response?.data?.newOrderPlanningId || "");
        setRowCount(response.data.pagination?.totalRecords || 0);
        setLoading(false)
      } else {
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
      console.error("Error fetching leads", error);
    }
  };
  const handleOpenDeleteAlert = (rowId) => {
    setDeleteAlert(true)
    setRowId(rowId)
  }
  useEffect(() => {
    getLeadList(page, pageSize)
  }, [token, page, pageSize, colorlist])
  useEffect(() => {
    getCommonData()
  }, [])
  const getCommonData = async () => {
    const clientCompany = await getClientCompany()
    setClientCompany(clientCompany)
    const colorData = await getColorPlate();
    setColorlist(colorData);
    const currencyListData = await getCurrencyList();
    setCurrencyList(currencyListData);
  }
  const handleOpen = () => {
    setLeadModal(true);
  };
  const handleClose = () => {
    setLeadModal(false)
  }

  return (
    <>
      <Box sx={{ padding: "10px" }}>
        <CustomLoader open={loading} />
        <CustomDataTable
          title={title}
          columns={columns}
          data={getAllLead}
          handleOpen={handleOpen}
          buttonTitle="Create"
          handleFilterButton={filterOpen}
          fiterButtonTitile="Filter"
          rowCount={rowCount}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          fromDate={filterPayload.fromDate || ""}
          toDate={filterPayload.toDate || ""}
        />
        <CustomModal open={leadModal}  >
          <CreateOrderPlanning
            handleClose={handleClose}
            newOrderPlanningId={newOrderPlanningId}
            suppliersList={clientCompany}
            currencyList={currencyList}
            statusList={statusList}
            orderTypeList={orderTypeList}
            fetchData={getLeadList}
            setMessage={setMessage}
          />
        </CustomModal>

        <CustomModal open={updateLeadModal}  >
          <UpdateOrderPlanning
            handleClose={handleCloseUpdateLead}
            selectedId={selectedOrderPlanningId}
            suppliersList={clientCompany}
            currencyList={currencyList}
            statusList={statusList}
            orderTypeList={orderTypeList}
            fetchData={getLeadList}
            setMessage={setMessage}
          />
        </CustomModal>

        <CustomModal open={viewLeadModal}>
          <ViewOrderPlanning
            handleClose={handleCloseViewLead}
            selectedId={selectedOrderPlanningId}
            suppliersList={clientCompany}
            currencyList={currencyList}
            statusList={statusList}
            orderTypeList={orderTypeList}
            fetchData={getLeadList}
            setMessage={setMessage}
          />
        </CustomModal>

        <MessageBox
          open={message.open}
          onClose={() => setMessage({ ...message, open: false })}
          message={message.text}
          handleClose={() => setMessage({ ...message, open: false })}
          type={message.type}
        />
        <CustomDelete
          handleDelete={handleDelete}
          open={deleteAlert}
          rowId={rowId}
          handleClose={() => setDeleteAlert(false)}
        />
        <CustomFilter
          drawerTitle="Filter"
          drawerWidth={300}
          openDrawer={openDrawer}
          onClose={filterClose}
          drawerContent={
            <>
              <Box>
                <Grid container spacing={1} sx={{ padding: 0, }}>
                  <Grid item xs={12}>
                    <CustomTextField
                      placeholder="Enter Order No"
                      value={filterPayload.orderNo}
                      onChange={(e) => handleFilterChange("orderNo", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomAutocomplete
                      options={clientCompany}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Company"
                      value={
                        clientCompany.find(
                          (item) => item.id === filterPayload.clientId
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        handleFilterChange("clientId", newValue?.id)
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <CustomAutocomplete
                      options={currencyList}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Currency"
                      value={
                        currencyList.find(
                          (item) => item.id === filterPayload.currencyId
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        handleFilterChange("currencyId", newValue?.id)
                      }
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <CustomAutocomplete
                      options={statusList}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Status"
                      value={
                        statusList.find(
                          (item) => item.id === filterPayload.status
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        handleFilterChange("status", newValue?.id)
                      }
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CustomAutocomplete
                      options={orderTypeList}
                      getOptionLabel={(option) => option.title}
                      placeholder="Select Order Type"
                      value={
                        orderTypeList.find(
                          (item) => item.id === filterPayload.commanShipmentId
                        ) || null
                      }
                      onChange={(event, newValue) =>
                        handleFilterChange("commanShipmentId", newValue?.id)
                      }
                    />
                  </Grid>

                  <Grid item xs={8} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="From Date"
                      type="date"
                      value={filterPayload.fromDate}
                      onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                      placeholder="From Date"
                    />
                  </Grid>
                  <Grid item xs={8} sm={12} md={12}>
                    <CustomTextField
                      fieldLabel="To Date"
                      type="date"
                      value={filterPayload.toDate}
                      onChange={(e) => handleFilterChange('toDate', e.target.value)}
                      placeholder="To Date"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} sx={{ display: 'flex', alignItems: 'center', marginTop: "10px" }}>
                    <CustomButton
                      startIcon={<FindReplaceOutlinedIcon />}
                      title="Apply"
                      size="small"
                      variant="contained"
                      onClick={getLeadList}
                    />
                    <CustomButton
                      variant="outlined"
                      title="Clear"
                      startIcon={<ClearRounded />}
                      style={cif_fob_style}
                      onClick={handleClearFilters}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          }
        />
      </Box>
    </>
  );
};
export default OrderPlanning;

const cif_fob_style = {
  backgroundColor: '#ffff',
  color: '#007bff',
  textTransform: "capitalize",
  borderRadius: 4,
  border: '1px solid #007bff',
  height: 30,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: "100px"
}
